import { Injectable } from '@angular/core';
import { getFirebaseBackend } from '../../authUtils';
import { User } from 'src/app/store/Authentication/auth.models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { catchError, map } from 'rxjs/operators';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { GlobalComponent } from "../../global-component";

import { RegisterSuccess, loginFailure, loginSuccess, logout, logoutSuccess } from 'src/app/store/Authentication/authentication.actions';

const AUTH_API = GlobalComponent.AUTH_API;

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

@Injectable({ providedIn: 'root' })

/**
 * Auth-service Component
 */
export class AuthenticationService {

    user!: User;
    currentUserValue: any;
    private currentUserSubject: BehaviorSubject<User>;

    constructor(private http: HttpClient, private store: Store) { 
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser')!));
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(email: string, first_name: string, password: string) {
        // return getFirebaseBackend()!.registerUser(email, password).then((response: any) => {
        //     const user = response;
        //     return user;
        // });

        // Register Api
        return this.http.post(AUTH_API + 'signup', {
            email,
            first_name,
            password,
        }, httpOptions).pipe(
            map((response: any) => {
                const user = response;
                return user;
            }),
            catchError((error: any) => {
                const errorMessage = 'Login failed'; // Customize the error message as needed
                this.store.dispatch(loginFailure({ error: errorMessage }));
                return throwError(errorMessage);
            })
        );
    }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(email: string, password: string) {
        // return getFirebaseBackend()!.loginUser(email, password).then((response: any) => {
        //     const user = response;
        //     return user;
        // });
        return this.http.post(AUTH_API + 'signin', {
            email,
            password
        }, httpOptions).pipe(
            map((response: any) => {
              const user = response;
              return user;
          }),
          catchError((error: any) => {
              const errorMessage = 'Login failed'; // Customize the error message as needed
              return throwError(errorMessage);
          })
      );
    }

    /**
     * Returns the current user
     */
    public currentUser(): any {
        return getFirebaseBackend()!.getAuthenticatedUser();
    }


    // autoLoginViaTokenAPI(): Promise<boolean> {
    //     const apiUrl = 'https://demo.lakee1508operation.com/order/zillion/token';
    //     const body = {
    //         customerId: '197',
    //         clientSecret: 'aDm5j99dklsk3hWLc03j323UEYgz224bkldk0903lnxcreekalpohs'
    //     };

    //     return this.http.post<any>(apiUrl, body).toPromise().then(res => {
    //         if (res?.status === 'success' && res.message) {
    //             const user = { token: res.message };
    //             sessionStorage.setItem('currentUser', JSON.stringify(user));
    //             this.currentUserSubject.next(user as User);
    //             return true;
    //         } else {
    //             return false;
    //         }
    //     }).catch(() => false);
    // }

    autoLoginViaTokenAPI(): Promise<boolean> {
        const apiUrl = 'https://lvalidate.lakeetech.com/token';
        const body = {
            merchant_id: 'g8qQvtiK6xSnybj',
            secret_key: 'G6AETVj299yKaYLb8zBc7GfHwjAaVMGWAQdqRzo4l5k='
        };

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': '*/*'
        });

        return this.http.post<any>(apiUrl, body, { headers }).toPromise().then(res => {
            if (res?.status === 'success' && res?.token) {
            const user = { token: res.token };

            // Save token for future use
            sessionStorage.setItem('currentUser', JSON.stringify(user));
            sessionStorage.setItem('token', res.token);  // Optional: for consistency
            this.currentUserSubject.next(user as User);

            return true;
            } else {
            return false;
            }
        }).catch((error) => {
            console.error('Token API failed', error);
            return false;
        });
}

    /**
     * Logout the user
     */
    logout() {
        // logout the user
        // return getFirebaseBackend()!.logout();
        sessionStorage.removeItem('currentUser');
        sessionStorage.removeItem('token');
        this.currentUserSubject.next(null!);
        return of(undefined).pipe(
        
        );
    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(email: string) {
        return getFirebaseBackend()!.forgetPassword(email).then((response: any) => {
            const message = response.data;
            return message;
        });
    }

}

